import { render, staticRenderFns } from "./poissaolo-form.vue?vue&type=template&id=5666fa7a&scoped=true&"
import script from "./poissaolo-form.vue?vue&type=script&lang=ts&"
export * from "./poissaolo-form.vue?vue&type=script&lang=ts&"
import style0 from "./poissaolo-form.vue?vue&type=style&index=0&id=5666fa7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5666fa7a",
  null
  
)

export default component.exports